const PREFIX = '@@STORY';
export const FETCH_STORY = `${PREFIX}/FETCH_STORY`;
export const START_LOADING = `${PREFIX}/START_LOADING`;
export const END_LOADING = `${PREFIX}/END_LOADING`;
